<template>
  <PublicPopup
    ref="PopupRef"
    background="transparent"
    padding="0"
    :border-size="0"
    @close="emit('close')"
  >
    <template #content>
      <AtividadeModel
        ref="ModelRef"
        type="site-message"
        :list="list"
        is-has-un-read
        @close="handlePopupClose"
      />
      <CheckboxPublic type="site-message" />
    </template>
  </PublicPopup>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { siteMessageList } from '@/api/user'

const route = useRoute()
const router = useRouter()

const SiteMessagePopupChecked = ref(window.localStorage.SiteMessagePopupChecked || 'null')

const ModelRef = ref(null)
const PopupRef = ref(null)
const open = () => {
  if (SiteMessagePopupChecked.value === 'checked') return false

  nextTick(() => {
    list.value.map((e) => (e['unRead'] = true))
    PopupRef.value.open()

    nextTick(() => {
      ModelRef.value.change(list.value[0])
    })
  })
}
const handlePopupClose = () => {
  PopupRef.value.close()
}

/**
 * id  * 活动ID
 * title  * 标题
 * content  * 富文本
 * img  * 图片
 * msg_type  * 消息类型[1-富文本][2-图片]
 * jump_type  * 跳转类型[1-内链][2-外链]
 * jump_url  * 跳转路由/链接
 * unRead  * 是否未读[true-未读][false-已读] {如有需求, 前端自己遍历添加变量}
 */
const list = ref([])
const pageData = reactive({
  page: 1,
  limit: 20,
})
const getList = async () => {
  list.value = []

  await siteMessageList({ read_status: 2 }).then((res) => {
    const resData = res.data

    if (resData && resData !== undefined) {
      const resList = resData.list

      if (resList && resList.length > 0) {
        resList.map((e) => (e['unRead'] = true))

        list.value = resList

        pageData.page++

        nextTick(() => {
          if (route.name === 'Home') {
            open()
          }
        })
      }
    }
  })
}

const emit = defineEmits(['close'])

defineExpose({
  getList,
  open,
})
</script>
